<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    title: {
      type: String,
      default: () => null,
    },
    totalContacts: {
      type: Number,
      default: () => null,
    },
    contactsSent: {
      type: Number,
      default: () => null,
    },
  },
});
</script>

<template>
  <div class="campaign-progress">
    <v-layout
      style=""
      row
    >
      <v-flex
        class="campaign-progress__title"
        grow
      >
        {{ title }}
      </v-flex>
      <v-flex
        class="campaign-progress__title"
        shrink
      >
        {{ Math.floor((contactsSent / totalContacts) * 100) }} %
      </v-flex>
    </v-layout>
    <v-progress-linear
      :color="contactsSent / totalContacts < 0.7 ? '#FF5146' : '#6ADDC8'"
      background-color="#DDDDDD"
      height="7"
      rounded
      :value="(contactsSent / totalContacts) * 100"
    />
    <div class="campaign-progress__contacts-sent">
      {{ contactsSent }} de {{ totalContacts }} contatos
    </div>
  </div>
</template>

<style lang="scss" scoped>
.campaign-progress {
  margin-top: 30px;
  font-size: 14pt;
  font-weight: bold;
  &__title {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
  }
  &__contacts-sent {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 8px;
  line-height: 11px;
  }
}
.v-progress-linear {
  margin-top: 10.5px;
  margin-right: 0px;
  margin-bottom: 10.5px;
  margin-left: 0px;
}
::v-deep .v-progress-linear {
  border-radius: 16px !important;
}
</style>
